import React from "react"; // eslint-disable-line no-unused-vars
import styled from "styled-components";
import { DropTarget } from "react-dnd";
import moment from "moment-timezone";

const AvailableContainer = styled.div`
    border-top: 1px solid #90f4ba;
    border-right: 1px solid #90f4ba;
  background-color: #fff;
  color: #444;
  padding: 5px;
  display: flex;
  //  border-top: 1px solid #eee;
//  border-right: 1px solid #fff;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;
    font-size:0.9em;
  /*background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAI0lEQVQYV2NkQAbHA/4zwvnHA/4zWG5ghAhAOSAmIzIHJAAAV1sLG03vu+QAAAAASUVORK5CYII=)
    repeat;*/
  background-color: #c7ffde;
  &:hover {
    background-color: #23f16a;
    &::before {
      content: "${props => props.time}";
    }
  }
`;
const Box = styled.div`
  background-color: #fff;
  color: #444;
  padding: 5px;
  display: flex;
  //  border-top: 1px solid #eee;
  border-right: 1px solid #fff;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: ${props => (props.time ? "0.9em" : "inherit")};
  border-top: ${props => (props.time ? "1px solid #eee" : "inherit")};
  &:nth-child(2) {
    border-top: ${props => (props.time ? "none" : "inherit")};
  }
`;
const Past = Box.extend`
  border-top: none;
  border-right: none;
  /*  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAM0lEQVQoU2NkwAP+////nxGXPFgSBLApgEmC5DAUIEtiKECXRFGATRKuAJckWAE+SZACAIKGIAUwJOAdAAAAAElFTkSuQmCC)
    repeat;*/
  /*url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAIklEQVQYV2NkQAI9PT3/GWF8EKekpIQRLADjgNiMyByQAADHBQ6o45FCxgAAAABJRU5ErkJggg==)
    repeat;*/
  //  background-color: #ccc;
  background-color: transparent;
`;

const AvailableContainerOver = AvailableContainer.extend`
  border-top: 1px solid #90f4ba;
  height: 100%;
  /*background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAI0lEQVQYV2NkQAbHA/4zwvnHA/4zWG5ghAhAOSAmIzIHJAAAV1sLG03vu+QAAAAASUVORK5CYII=)
    repeat;*/
  background-color: #23f16a;
  &::before {
    content: "${props => props.time}";
  }
`;

const availableTarget = {
  drop(props, monitor, component) {
    props.moveEvent(monitor.getItem().id, props.date);
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

class Available extends React.Component {
  state = { isPast: false };

  componentDidMount() {
    let interval = (this.props.date.diff(moment(), "minutes") + 1) * 60000;
    if (interval >= 2147483647) {
      interval = 2147483647;
    }
    this.interval = setTimeout(() => {
      this.setState({
        isPast: true
      });
    }, interval);
  }
  componentWillUnmount() {
    clearTimeout(this.interval);
  }

  render() {
    const { connectDropTarget, isOver } = this.props;

    if (this.state.isPast) {
      return (
        <div>
          <Past />
        </div>
      );
    }

    if (isOver) {
      return connectDropTarget(
        <div>
          <AvailableContainerOver time={this.props.time} />
        </div>
      );
    }

    return connectDropTarget(
      <div>
        <AvailableContainer
          time={this.props.time}
          onClick={this.props.availableSlotClick}
        />
      </div>
    );
  }
}

export default DropTarget("event", availableTarget, collect)(Available);



// WEBPACK FOOTER //
// ./src/components/utilities/calendar/Available.js